import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Tccss.css'
import tclogo from '../Assets/Images/tc.png'

function Tcnavbar({ openSidebar}) {

    useEffect(() => {
     document.getElementById("name").innerHTML = localStorage.getItem("username");
     document.getElementById("role").innerHTML = localStorage.getItem("Role");
},[]);
    return (
        <div className='TC-navbar'>
        <div className='TC-nav-icon' >
            <i className='fa fa-bars' onClick={openSidebar}></i>
        </div>

        <div className='TC-navbar-left'>
        <div className='TC-sidebar-img'>
        <img src={tclogo} alt="logo"/>&nbsp;&nbsp;           
        </div> 
        </div>

        <div className='TC-navbar-right'>
       
           <a>
            <i class="fa fa-user-circle" aria-hidden="true"></i>
            </a>
            <div className='TC-right-navbar'>
            <span id="name"></span>
            (<span id="role"></span>)
            
            </div>
            
        </div>
    </div>
    );
}

export default Tcnavbar;